import { render, staticRenderFns } from "./foods.vue?vue&type=template&id=a3fe4254&scoped=true"
import script from "./foods.vue?vue&type=script&lang=js"
export * from "./foods.vue?vue&type=script&lang=js"
import style0 from "./foods.vue?vue&type=style&index=0&id=a3fe4254&prod&lang=scss&scoped=true"
import style1 from "./foods.vue?vue&type=style&index=1&id=a3fe4254&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fe4254",
  null
  
)

export default component.exports